
// Profile routing configuration and logic
interface ProfileRoutingConfig {
  // Test users that should use /gprofile
  testUserPatterns: string[];
  // Specific user IDs that should use /gprofile
  specificUserIds: string[];
  // Username patterns that should use /gprofile
  usernamePatterns: string[];
  // Default route for regular users
  defaultRoute: 'profile' | 'gprofile';
}

const profileRoutingConfig: ProfileRoutingConfig = {
  testUserPatterns: ['x001', 'x002', 'x003', 'x004', 'x005', 'tux001', 'tux002', 'tux003', 'tux004', 'tux005'], // Test users with flexible patterns
  specificUserIds: [], // Add specific user IDs here if needed
  usernamePatterns: ['test_', 'demo_', 'tux', 'x00'], // Username patterns
  defaultRoute: 'gprofile' // All users now use the modern /gprofile page
};

export const profileRouterService = {
  /**
   * Determines which profile route to use for a given user
   */
  getProfileRoute(userId: string, username?: string, displayName?: string): string {
    console.log('🔍 Using /gprofile route for user:', userId);
    return `/gprofile/${userId}`;
  },

  /**
   * Determines if a user should use the modern /gprofile page
   */
  shouldUseGprofile(userId: string, username?: string, displayName?: string): boolean {
    console.log('✅ All users now use gprofile');
    return true;
  },

  /**
   * Update routing configuration
   */
  updateConfig(newConfig: Partial<ProfileRoutingConfig>) {
    Object.assign(profileRoutingConfig, newConfig);
  },

  /**
   * Get current configuration
   */
  getConfig(): ProfileRoutingConfig {
    return { ...profileRoutingConfig };
  }
};
